module.exports = __webpack_public_path__ + "img/uploaded-file-type-image.d20d7255.svg";